import { Injectable, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { AppComponent } from '../app.component';

const API_WINKELS_ENDPOINT = '/shop';
@Injectable({
  providedIn: 'root'
})
export class WinkelService {

  constructor(private http: HttpClient) { }
  getWinkels(): Observable<any> {
    return this.http.get(AppComponent.baseUrl + API_WINKELS_ENDPOINT + '/overview', { responseType: 'text' });
  }
  addWinkel(postData): Observable<any> {
    return this.http.post(AppComponent.baseUrl + API_WINKELS_ENDPOINT + '/add-shop', postData, { responseType: 'text' });
  }
  getWinkel(id): Observable<any> {
    return this.http.get(AppComponent.baseUrl + API_WINKELS_ENDPOINT + '/get-shop?id=' + id, { responseType: 'text' });
  }
  deleteWinkel(id): Observable<any> {
    return this.http.get(AppComponent.baseUrl + API_WINKELS_ENDPOINT + '/remove-shop?id=' + id, { responseType: 'text' });
  }

  getShopCategories(shopId: number): Observable<any> {
    return this.http.get(AppComponent.baseUrl + '/shop-category/categories/' + shopId, { responseType: 'text' });
  }

  saveShopCategoryOrder(shopId: number, categories: { id: number; order: number }[]): Observable<any> {
    return this.http.post(AppComponent.baseUrl + '/shop-category/save-order', { shop_id: shopId, categories }, { responseType: 'text' });
  }

}
